import { render, staticRenderFns } from "./OrderablePreviewShippingAddress.vue?vue&type=template&id=378e4e71&"
import script from "./OrderablePreviewShippingAddress.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewShippingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports